"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requests = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _superagentPromise = _interopRequireDefault(require("superagent-promise"));
var _superagent2 = _interopRequireDefault(require("superagent"));
var _createParametrizedUrl = _interopRequireDefault(require("@deosite/helpers/createParametrizedUrl"));
var superagent = (0, _superagentPromise["default"])(_superagent2["default"], global.Promise);
var handleErrors = function handleErrors(_ref) {
  var _err$response$status2, _err$response2;
  var err = _ref.err,
    url = _ref.url,
    language = _ref.language,
    elastic = _ref.elastic,
    _ref$isExternal = _ref.isExternal,
    isExternal = _ref$isExternal === void 0 ? false : _ref$isExternal;
  if (typeof window !== "undefined") {
    return err;
  }
  if (isExternal) {
    var _err$response$status, _err$response;
    console.error("Request error external url: ".concat((_err$response$status = err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status) !== null && _err$response$status !== void 0 ? _err$response$status : JSON.stringify(err), ", url: ").concat(url));
  }
  var _ref2 = language !== null && language !== void 0 ? language : {},
    lang = _ref2.lang,
    domain = _ref2.domain;
  var directUrl = "".concat((0, _createParametrizedUrl["default"])(global.__appConfig__.elasticEndpointUrl, {
    lang: lang,
    domain: domain
  })).concat(url);
  if (!elastic) {
    directUrl = "".concat((0, _createParametrizedUrl["default"])(global.__appConfig__.restRootEndpointUrl, {
      lang: lang,
      domain: domain
    })).concat(url);
  }
  console.error("Request get errors status: ".concat((_err$response$status2 = err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.status) !== null && _err$response$status2 !== void 0 ? _err$response$status2 : JSON.stringify(err), ", url: ").concat(directUrl, ", lang: ").concat(JSON.stringify(lang)));
  return err;
};
var responseBody = function responseBody(res) {
  return res.body;
};
var tokenPlugin = function tokenPlugin(req, token) {
  if (token) {
    req.set("Authorization", "Bearer ".concat(token));
  }
};
var requests = {
  del: function del(url, token, lang) {
    return superagent.del(requests.getUrl(url, false, lang)).withCredentials().use(function (req) {
      return tokenPlugin(req, token);
    }).then(responseBody);
  },
  get: function () {
    var _get = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(url) {
      var elastic,
        token,
        lang,
        request,
        res,
        _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              elastic = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
              token = _args.length > 2 ? _args[2] : undefined;
              lang = _args.length > 3 ? _args[3] : undefined;
              _context.prev = 3;
              request = superagent.get(requests.getUrl(url, elastic, lang)).withCredentials().use(function (req) {
                return tokenPlugin(req, token);
              });
              if (typeof window === "undefined") {
                request.set("User-Agent", "DAppRequester/1.0");
              }
              _context.next = 8;
              return request;
            case 8:
              res = _context.sent;
              return _context.abrupt("return", responseBody(res));
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);
              return _context.abrupt("return", handleErrors({
                err: _context.t0,
                url: url,
                language: lang,
                elastic: elastic
              }));
            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 12]]);
    }));
    function get(_x) {
      return _get.apply(this, arguments);
    }
    return get;
  }(),
  put: function put(url, body, token, lang) {
    return superagent.put(requests.getUrl(url, false, lang), body).withCredentials().use(function (req) {
      return tokenPlugin(req, token);
    }).then(responseBody);
  },
  post: function post(url, body, token, lang) {
    return superagent.post(requests.getUrl(url, false, lang), body).withCredentials().use(function (req) {
      return tokenPlugin(req, token);
    }).then(responseBody);
  },
  putExternal: function putExternal(url, body) {
    var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    return superagent.put(url, body).use(function (req) {
      return token.length > 0 ? tokenPlugin(req, token) : req;
    }).then(responseBody);
  },
  postExternal: function postExternal(url, body) {
    var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    return superagent.post(url, body).use(function (req) {
      return token.length > 0 ? tokenPlugin(req, token) : req;
    }).then(responseBody);
  },
  delExternal: function delExternal(url, body) {
    var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    return superagent.del(url, body).use(function (req) {
      return token.length > 0 ? tokenPlugin(req, token) : req;
    });
  },
  getExternal: function getExternal(url, body) {
    var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    return superagent.get(url, body).use(function (req) {
      return token.length > 0 ? tokenPlugin(req, token) : req;
    }).withCredentials().then(responseBody);
  },
  getWithKey: function getWithKey(url, keyName, keyValue, query) {
    return superagent.get(url).query(query).set(keyName, keyValue).then(responseBody);
  },
  getUrl: function getUrl(url) {
    var elastic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var language = arguments.length > 2 ? arguments[2] : undefined;
    var lang = language.language,
      domain = language.domain;
    if (!elastic) {
      return "".concat((0, _createParametrizedUrl["default"])(global.__appConfig__.restRootEndpointUrl, {
        lang: lang,
        domain: domain
      })).concat(url);
    }
    return "".concat((0, _createParametrizedUrl["default"])(global.__appConfig__.elasticEndpointUrl, {
      lang: lang,
      domain: domain
    })).concat(url);
  }
};
exports.requests = requests;